/* @flow strict */

import * as React from 'react';
import _ from 'lodash';

const customizeBackendError = (er: string): string => {
  if (er === 'The field ConfirmationEmailGreeting must be a string with a maximum length of 5000.') {
    return  'The Custom Email Confirmation message cannot exceed 7500 characters. Please reduce your text and try saving again.';
  }

  if (er.startsWith('The field UrlName must match the regular expression')) {
    return 'The URL for your event has invalid characters. Make sure there are only numbers, letters, symbol "-" and at least one letter in the Event page URL (required) field';
  }

  return er;
};

export const GetErrorValidation = ({ data }: any): any =>  {
  const errors = _.get(data, 'error.validation_errors', null);
  const errorMsg = _.get(data, 'error.message', null);

  if (!errors && !errorMsg) {
    return 'Something went wrong.';
  }

  if (!errors) {
    return errorMsg;
  }

  const unique = _.uniqBy(errors, (er: {}): string => er.message); // prevent duplicates

  if (unique.length === 1) {
    return customizeBackendError(unique[0].message);
  }

  return (
    <ul style={{ listStyle: 'disc', paddingLeft: '20px' }}>
      {_.map(unique, (er: {}, key: number): string => (
        <li key={key}>{customizeBackendError(er.message)}</li>
      ))}
    </ul>
  );
};
